<template>
  <Exception type="500" />
</template>

<script>
import Exception from "@/components/Exception";

export default {
  components: { Exception },
};
</script>
